import { Box } from '@chakra-ui/react';
import * as React from 'react';
import FormLoader from '../../../core/components/Loader/Form/FormLoader';
import { useLoadScript } from '../../../core/hooks/useLoadScript';

export interface CmsFormProps {
  id: string;
}

const CmsForm = ({ id }: CmsFormProps): React.ReactElement | null => {
  const loaded = useLoadScript('https://webforms.pipedrive.com/f/loader');

  return (
    <Box
      p={[4, 6, 8, 8, 12]}
      borderRadius="lg"
      boxShadow="card"
      w="full"
      bgColor="white"
      css={{ iframe: { width: '100%' } }}
    >
      <div
        style={{ width: '100%' }}
        className="pipedriveWebForms"
        data-pd-webforms={`https://webforms.pipedrive.com/f/${id}`}
      ></div>
      {!loaded && <FormLoader label button />}
    </Box>
  );
};
export default CmsForm;
